import { render, staticRenderFns } from "./LiveCurrencyCrossRatesByInvesting.vue?vue&type=template&id=6817846b&"
import script from "./LiveCurrencyCrossRatesByInvesting.vue?vue&type=script&lang=js&"
export * from "./LiveCurrencyCrossRatesByInvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports